import {EnvironmentSpecificService} from '../services/environmentspecific.service';
export function ConfigLoader(envService: EnvironmentSpecificService) {
    return () => envService.loadEnvironment();
}
